import {
  authorizedJsonRequest, handleWebResourceFailure, listData,
} from './web-resource-api';

require('dotenv').config();

const ENV = process.env;
const SORT_FIELDS = [
  'id', 'country_id', 'ISOcountryCode', 'name_en', 'name_fr', 'name_ar',
  'description_en', 'description_fr', 'description_ar', 'timezone', 'enabled',
  'createdAt', 'updatedAt',
];

export const REQUEST_WEB_COUNTRIES = 'REQUEST_WEB_COUNTRIES';
export const RECEIVE_WEB_COUNTRIES = 'RECEIVE_WEB_COUNTRIES';
export const RECEIVE_WEB_COUNTRY = 'RECEIVE_WEB_COUNTRY';
export const COMPLETE_WEB_COUNTRIES = 'COMPLETE_WEB_COUNTRIES';

export const requestWebCountries = () => ({ type: REQUEST_WEB_COUNTRIES });
export const receivedWebCountries = items => ({ type: RECEIVE_WEB_COUNTRIES, items });
export const receivedWebCountry = item => ({ type: RECEIVE_WEB_COUNTRY, item });
export const completeWebCountries = () => ({ type: COMPLETE_WEB_COUNTRIES });

const mutation = (url, method, params) => dispatch => (
  authorizedJsonRequest(url, {
    method,
    headers: method === 'DELETE' ? {} : { 'Content-Type': 'application/json' },
    ...(params ? { body: JSON.stringify(params) } : {}),
  }).then((result) => {
    if (!result.ok) handleWebResourceFailure(dispatch, result);
    dispatch(completeWebCountries());
    return result;
  })
);

export const fetchWebCountries = sort => (dispatch) => {
  dispatch(requestWebCountries());
  let url = `${ENV.REACT_APP_API_SERVER}/web-countries`;
  if (sort && SORT_FIELDS.includes(sort[0])) url += `?order=${JSON.stringify(sort)}`;

  return authorizedJsonRequest(url, { method: 'GET' }).then((result) => {
    if (result.ok) dispatch(receivedWebCountries(listData(result.data)));
    else {
      handleWebResourceFailure(dispatch, result);
      dispatch(receivedWebCountries([]));
    }
    return result;
  });
};

export const fetchWebCountry = id => (dispatch) => {
  dispatch(requestWebCountries());
  return authorizedJsonRequest(`${ENV.REACT_APP_API_SERVER}/web-countries/${id}`, { method: 'GET' })
    .then((result) => {
      if (result.ok) dispatch(receivedWebCountry(result.data));
      else {
        handleWebResourceFailure(dispatch, result);
        dispatch(receivedWebCountry({}));
      }
      return result;
    });
};

export const createWebCountry = params => (dispatch) => {
  dispatch(requestWebCountries());
  return mutation(`${ENV.REACT_APP_API_SERVER}/web-countries`, 'POST', params)(dispatch);
};

export const saveWebCountry = (id, params) => (dispatch) => {
  dispatch(requestWebCountries());
  return mutation(`${ENV.REACT_APP_API_SERVER}/web-countries/${id}`, 'POST', params)(dispatch);
};

export const deleteWebCountry = id => (dispatch) => {
  dispatch(requestWebCountries());
  return mutation(`${ENV.REACT_APP_API_SERVER}/web-countries/${id}`, 'DELETE')(dispatch);
};
